import { AppAPI, } from '@moderepo/mode-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var AuthActionType;
(function (AuthActionType) {
    AuthActionType["AUTHENTICATING"] = "authenticating";
    AuthActionType["AUTHENTICATE_SUCCESS"] = "authenticate success";
    AuthActionType["AUTHENTICATE_FAILURE"] = "authenticate failure";
    AuthActionType["SET_LOGIN_INFO"] = "set login info";
    AuthActionType["UPDATE_LOGGED_IN_USER"] = "update logged in user";
    AuthActionType["LOGOUT_USER"] = "logout user";
})(AuthActionType || (AuthActionType = {}));
export const authenticating = () => {
    return {
        type: AuthActionType.AUTHENTICATING,
    };
};
export const authenticateSuccess = (user) => {
    return {
        type: AuthActionType.AUTHENTICATE_SUCCESS,
        loggedInUser: user,
    };
};
export const authenticateFailure = () => {
    return {
        type: AuthActionType.AUTHENTICATE_FAILURE,
    };
};
export const setLoginInfo = (loginInfo) => {
    return {
        type: AuthActionType.SET_LOGIN_INFO,
        loginInfo,
    };
};
export const updateLoggedInUser = (user) => {
    return {
        type: AuthActionType.UPDATE_LOGGED_IN_USER,
        loggedInUser: user,
    };
};
export const userLogout = () => {
    return {
        type: AuthActionType.LOGOUT_USER,
    };
};
/**
 * Authenticate the user to make sure he is logged in by fetching the user's profile. If he is not logged
 * in or his token expired, an error will be thrown.
 * @param userId - number - The id of the user whose profile is to be loaded
 */
export const authenticateUser = (userId) => {
    return async (dataDispatch) => {
        // flag that we are authenticating so that the UI doesn't do anything.
        await dataDispatch(authenticating());
        try {
            const user = await AppAPI.getInstance().getUserById(userId);
            await dataDispatch(authenticateSuccess(user));
        }
        catch (error) {
            await dataDispatch(authenticateFailure());
            throw error;
        }
    };
};
/**
 * Get the logged in user's session info to check if the user is logged in.
 */
export const getUserSession = () => {
    return async () => {
        await AppAPI.getInstance().getUserSessionInfo();
        // TODO - Add userSession to the state
    };
};
/**
 * This is for fetching the LOGGED IN user's personal profile.
 */
export const fetchUserProfile = (userId) => {
    return async (dataDispatch) => {
        const user = await AppAPI.getInstance().getUserById(userId);
        await dataDispatch(authenticateSuccess(user));
    };
};
/**
 * This is for updating the LOGGED IN user's personal profile.
 */
export const updateUserProfile = (userId, params) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().updateUser(userId, params);
        await dataDispatch(fetchUserProfile(userId));
    };
};
/**
 * Log the user out
 */
export const logoutUser = () => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().logout();
        AppAPI.getInstance().clearAuthToken(); // Delete login info from AppAPI
        await dataDispatch(userLogout());
    };
};
